import React from 'react';
import { Box, Typography, Chip, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import PlayCircleIcon from '@mui/icons-material/PlayCircleFilled';
import { getHotTopicItemImageUrl } from '../../../utils/hot-topic';

// Custom styles
const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px'
  },
  imageContainer: {
    marginRight: 16,
    width: 206,
    height: 117,
    borderRadius: '8px 0 0 8px'
  },
  image: {
    objectFit: 'cover'
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  info: {
    flexGrow: 1
  },
  title: {
    color: '#161616',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    marginRight: 8
  },
  // tagsRow: {
  //   display: 'flex',
  //   alignItems: 'flex-end'
  // },
  // chipContainer: {
  //   marginRight: 8
  // },

  right: {
    width: 24,
    height: 24,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  playCircle: {
    width: 20,
    height: 20,
    background: '#616161',
    borderRadius: '50%'
  },
  playIcon: {
    color: '#616161',
    fontSize: 24
  }
}));

export default function VideoCardLandscape({ locale, itemData, onClick, maxTagLength = 2, ...props }) {
  const { title, tags } = itemData;
  const { classes } = useStyles();
  const thumbnailImageUrl = getHotTopicItemImageUrl(itemData);
  return (
    <Box className={classes.root} onClick={onClick}>
      <Box className={classes.left}>
        <Box
          className={classes.imageContainer}
          style={{
            backgroundImage: `url(${thumbnailImageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      </Box>
      <Typography className={classes.title}>{title[locale]}</Typography>
      {/* <Box className={classes.rightContainer}> */}

      {/* {tags && tags.length > 0 && (
          <Grid container spacing={1} className={classes.tagsRow}>
            {tags.slice(0, maxTagLength).map((tag, index) => (
              <Grid key={index} className={classes.chipContainer}>
                <GSTag label={tag[locale]} color={index} />
              </Grid>
            ))}
            {tags.length > maxTagLength && (
              <Grid className={classes.moreIconContainer}>
                <MoreHorizIcon />
              </Grid>
            )}
          </Grid>
        )} */}
      {/* </Box> */}
    </Box>
  );
}
